const SIDEBAR_WIDTH_COLLAPSED = 40;
const SIDEBAR_STORAGE_KEY = 'sidebar_expanded';

window.timerResizeSidebar = 0;

function isMobile() {
    return $('body').width() < 768;
}

function setSidebarExpanded(expanded) {
    if (expanded) {
        $('.sidebar').css('width', '');
        $('.sidebar').find('span').show();
        $('.main').css('width', '');
        $('#sidebar-toggle').addClass('is-expanded');
    } else {
        $('.sidebar').css('width', SIDEBAR_WIDTH_COLLAPSED + 'px');
        $('.sidebar').find('span').hide();
        $('.main').css('width', $('body').width() - SIDEBAR_WIDTH_COLLAPSED);
        $('#sidebar-toggle').removeClass('is-expanded');
    }
}

window.expandSidebar = function () {
    setSidebarExpanded(true);
};

window.collapseSidebar = function () {
    setSidebarExpanded(false);
};

window.initSidebar = function () {
    if (isMobile()) {
        setSidebarExpanded(true);
        return;
    }

    const stored = localStorage.getItem(SIDEBAR_STORAGE_KEY);
    const expanded = stored === null ? false : stored === 'true';
    setSidebarExpanded(expanded);
};

window.resizeSidebar = function () {
    clearTimeout(timerResizeSidebar);
    timerResizeSidebar = setTimeout(function () {
        if (isMobile()) {
            setSidebarExpanded(true);
        } else {
            const expanded = localStorage.getItem(SIDEBAR_STORAGE_KEY) === 'true';
            setSidebarExpanded(expanded);
        }
    }, 1000);
};

$('#sidebar-toggle').on('click', function () {
    if (isMobile()) {
        return;
    }

    const currentlyExpanded = $(this).hasClass('is-expanded');
    const newExpanded = !currentlyExpanded;

    setSidebarExpanded(newExpanded);
    localStorage.setItem(SIDEBAR_STORAGE_KEY, String(newExpanded));
    resizeChosen();
});
